const { freeze } = Object;

export const literalSizeDefault = 'md';
const literalSizes = freeze(['sm', literalSizeDefault, 'lg', 'xl']);

export const modalLiteralSizes = literalSizes;
export const iconLiteralSizes = literalSizes;

export const tooltipLiteralPlacement = freeze([
    'auto',
    'left',
    'right',
    'top',
    'bottom'
]);

// Sticky alert statuses
export const ALERT_STATUS = {
    SUCCESS: 'success',
    DANGER: 'danger',
    WARNING: 'warning'
};
